import { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router";
import { createClient, isSupabaseConfigured } from "@/lib/supabase/client";

export function AuthGuard() {
  const [state, setState] = useState<"loading" | "authenticated" | "unauthenticated">("loading");

  useEffect(() => {
    if (!isSupabaseConfigured) {
      setState("authenticated");
      return;
    }

    const supabase = createClient();
    supabase.auth.getUser().then(({ data }: { data: { user: unknown } }) => {
      setState(data.user ? "authenticated" : "unauthenticated");
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event: string, session: unknown) => {
      setState(session ? "authenticated" : "unauthenticated");
    });

    return () => subscription.unsubscribe();
  }, []);

  if (state === "loading") {
    return (
      <div className="flex h-svh items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Carregando...</div>
      </div>
    );
  }

  if (state === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
